import React from 'react';
import Header from "@/Components/Front/Header";
import Footer from "@/Components/Front/Footer";
import useLang from "@/Hooks/useLang";

export default function AppLayout(props) {
    const [lang, setLang] = useLang(props.locale);


    const textProps = {
        lang: lang, language: props.language,
    };


    return (
       <div>
                {props.children}
        </div>
    );
}
